<template>
  <div class="image-field-editor">
    <label class="editor-label">Image Preview:</label>
    <div class="image-preview">
      <img 
        :src="fieldData.src ? 'https://nyenyeziaforex.com/img/' + fieldData.src : defaultImage" 
        alt="Preview" 
        class="preview-img" 
      />
    </div>

    <label class="editor-label">Image URL:</label>
    <input
      type="text"
      :value="fieldData.src"
      @input="updateField('src', $event.target.value)"
      placeholder="Enter image URL"
      class="form-control"
    />

    <label class="editor-label">Upload Image:</label>
    <input
      type="file"
      @change="handleFileUpload"
      accept="image/*"
      class="file-input"
    />

    <button 
      type="button" 
      @click="clearImage" 
      class="btn-clear"
    >
      Clear Image
    </button>
  </div>
</template>

<script>
export default {
  name: 'ImageFieldEditor',
  props: {
    fieldData: Object,
    fieldKey: String,
  },
  data() {
    return {
      defaultImage: "https://via.placeholder.com/150", // Default placeholder image
    };
  },
  methods: {
    updateField(fieldName, value) {
      this.$emit('update-field', { key: this.fieldKey, fieldName, value });
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = () => {
          this.updateField('src', reader.result); // Update the image with the base64 data
        };
        reader.readAsDataURL(file);
      }
    },
    clearImage() {
      this.updateField('src', ""); // Clear the image
    },
  },
};
</script>

<style scoped>
.image-field-editor {
  background-color: #f9f9f9;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.editor-label {
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 5px;
  color: #333;
}

.image-preview {
  text-align: center;
  margin-bottom: 15px;
}

.preview-img {
  width: 100%;
  max-height: 200px;
  object-fit: contain;
  border: 1px solid #ddd;
  border-radius: 8px;
}

.form-control {
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 1rem;
  width: 100%;
}

.file-input {
  display: block;
  margin-top: 5px;
}

.btn-clear {
  background-color: #dc3545;
  color: white;
  border: none;
  padding: 10px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1rem;
  transition: background-color 0.3s ease;
  max-width: 400px;
}

.btn-clear:hover {
  background-color: #c82333;
}
</style>
